var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/business/calendar_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 2C11.0086 2 11.2903 2.25736 11.3288 2.58892L11.3333 2.66667V3.33333H12.6667C13.3696 3.33333 13.9454 3.87725 13.9963 4.56716L14 4.66667V12.6667C14 13.3696 13.4561 13.9454 12.7662 13.9963L12.6667 14H3.33333C2.63043 14 2.05456 13.4561 2.00366 12.7662L2 12.6667V4.66667C2 3.96376 2.54392 3.38789 3.23383 3.33699L3.33333 3.33333H4.66667V2.66667C4.66667 2.29848 4.96515 2 5.33333 2C5.67522 2 5.957 2.25736 5.99551 2.58892L6 2.66667V3.33333H10V2.66667C10 2.29848 10.2985 2 10.6667 2ZM12.6667 8H3.33333V12.6667H12.6667V8ZM12.6667 4.66667H3.33333V6.66667H12.6667V4.66667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar_line.ee6dace9c334e76c95e8d890fb17caa5.svg";
export { ForwardRef as ReactComponent };